import { createEntityAdapter, createSelector } from '@reduxjs/toolkit';
import groupBy from 'lodash/groupBy';
import { BoothTaxonomy } from './types';

export const boothTaxonomiesAdapter = createEntityAdapter<BoothTaxonomy>({});

export const selectBoothTaxonomiesState = (state: any) => state.cms?.boothTaxonomies || {};

export const selectBoothTaxonomiesFetchingState = (state: any) => !!state.cms?.boothTaxonomies?.fetching;

export const {
  selectIds: selectBoothTaxonomyIds,
  selectEntities: selectBoothTaxonomyEntities,
  selectAll: selectAllBoothTaxonomies,
  selectById: selectBoothTaxonomyById,
  selectTotal: selectTotalBoothTaxonomies,
} = boothTaxonomiesAdapter.getSelectors(selectBoothTaxonomiesState);

export const selectBoothTaxonomies = createSelector(
  selectAllBoothTaxonomies,
  (taxonomies) => {
    const parents = groupBy(taxonomies, (taxonomy: any) => taxonomy.parentSupercategory?.id);
    return taxonomies.map((taxonomy: any) => {
      if (!taxonomy.parentSupercategory?.id && parents[taxonomy.id]) {
        return { ...taxonomy, subcategories: parents[taxonomy.id] };
      }
      return taxonomy;
    });
  },
);

export const selectSelectedCategoryIds = createSelector(
  selectBoothTaxonomiesState,
  (state) => state.selectedCategoryIds,
);

export const selectBoothTaxonomiesEntities = createSelector(
  selectBoothTaxonomies,
  (boothTaxonomies) => boothTaxonomies
    .reduce((sum, next) => ({ ...sum, [next.id]: next }), {}) as Record<string, BoothTaxonomy>,
);

export const getFilterOptions = () => createSelector(
  [selectBoothTaxonomies, selectBoothTaxonomyEntities],
  (boothTaxonomies, entities) => {
    const grouped = groupBy(boothTaxonomies, (it) => Array.isArray(it.subcategories));
    if (!grouped.true) return grouped.false || [];
    return grouped.true.map((it) => ({
      ...it,
      subcategories: it.subcategories.map((sub) => entities[sub.id]),
    }));
  },
);
